import { History } from '@thehubz/client/data-access-api';
import { historyActionTypeLabels } from '../constants/history-action-type-labels.constant';

export function getHistoryActionLabel(entityType: History.EntityTypeEnum, actionPerformed: History.ActionPerformedEnum) {
  return historyActionTypeLabels['Common'][actionPerformed] || historyActionTypeLabels[entityType][actionPerformed] || '';
}
